import React from "react";
import { SITE } from "@/lib/site";

export default function MentionsLegalesPage() {
  return (
    <div data-testid="mentions-legales-page">
      <section className="bg-black text-white py-24 lg:py-32">
        <div className="container-soft">
          <p className="overline text-white/60">Informations légales</p>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl mt-4 tracking-tight leading-[1.05]">
            Mentions légales
          </h1>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="container-soft max-w-3xl">
          <div className="space-y-12 text-neutral-800">
            <div>
              <h2 className="font-serif-display text-2xl mb-4">1. Éditeur du site</h2>
              <ul className="space-y-2 leading-relaxed">
                <li><strong className="font-medium">Raison sociale :</strong> Pompes Funèbres Lumière des Nations</li>
                <li><strong className="font-medium">Forme juridique :</strong> [À compléter — SARL / EURL / Auto-entreprise]</li>
                <li><strong className="font-medium">Adresse du siège :</strong> {SITE.address}</li>
                <li><strong className="font-medium">Téléphone :</strong> <a href={SITE.phoneHref} className="underline">{SITE.phone}</a></li>
                <li><strong className="font-medium">Email :</strong> <a href={`mailto:${SITE.email}`} className="underline break-all">{SITE.email}</a></li>
                <li><strong className="font-medium">SIRET :</strong> [À compléter]</li>
                <li><strong className="font-medium">N° TVA intracommunautaire :</strong> [À compléter]</li>
                <li><strong className="font-medium">Directeur de la publication :</strong> [Nom du responsable]</li>
              </ul>
            </div>

            <div className="hairline" />

            <div>
              <h2 className="font-serif-display text-2xl mb-4">2. Habilitation funéraire</h2>
              <p className="leading-relaxed">
                Conformément à l'article L. 2223-23 du Code général des collectivités territoriales,
                Pompes Funèbres Lumière des Nations est habilitée par la Préfecture des
                Pyrénées-Orientales pour exercer les activités funéraires.
              </p>
              <p className="leading-relaxed mt-3">
                <strong className="font-medium">Numéro d'habilitation préfectorale :</strong> [À compléter]
              </p>
            </div>

            <div className="hairline" />

            <div>
              <h2 className="font-serif-display text-2xl mb-4">3. Hébergement du site</h2>
              <p className="leading-relaxed">
                Le site <a href="https://pompesfunebresbaho.com" className="underline">pompesfunebresbaho.com</a> est hébergé par :
              </p>
              <ul className="space-y-2 leading-relaxed mt-3">
                <li><strong className="font-medium">Hébergeur :</strong> Emergent</li>
                <li><strong className="font-medium">Site :</strong> <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="underline">emergent.sh</a></li>
              </ul>
            </div>

            <div className="hairline" />

            <div>
              <h2 className="font-serif-display text-2xl mb-4">4. Propriété intellectuelle</h2>
              <p className="leading-relaxed">
                L'ensemble des contenus présents sur ce site (textes, images, logos, identité visuelle)
                est la propriété exclusive de Pompes Funèbres Lumière des Nations, sauf mention contraire.
                Toute reproduction, représentation, modification ou exploitation, totale ou partielle,
                sans l'accord écrit préalable de l'éditeur, est interdite et constituerait une
                contrefaçon sanctionnée par les articles L. 335-2 et suivants du Code de la propriété intellectuelle.
              </p>
            </div>

            <div className="hairline" />

            <div>
              <h2 className="font-serif-display text-2xl mb-4">5. Crédits photos</h2>
              <p className="leading-relaxed">
                Photographies d'illustration : Unsplash (licence libre de droits).
              </p>
            </div>

            <div className="hairline" />

            <div>
              <h2 className="font-serif-display text-2xl mb-4">6. Médiation de la consommation</h2>
              <p className="leading-relaxed">
                Conformément à l'article L. 612-1 du Code de la consommation, en cas de litige
                non résolu à l'amiable, le consommateur peut recourir gratuitement au service de
                médiation de la consommation suivant : [À compléter — Médiateur sectoriel]
              </p>
            </div>

            <div className="hairline" />

            <div>
              <h2 className="font-serif-display text-2xl mb-4">7. Loi applicable</h2>
              <p className="leading-relaxed">
                Les présentes mentions légales sont régies par le droit français. En cas de litige,
                les tribunaux français seront seuls compétents.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
